export default {
  clientId: "",
  recaptchaPublicKey: "",
};
